// types of users sharing permissions
const financeGroup = ['admin', 'superadmin', 'finance_agent'];

export default {
  FinanceGroup: financeGroup,
};
